import { DateTime } from 'luxon';
export function timeStampToDate(timeStamp) {
  const date = DateTime.fromMillis(Number(timeStamp))
    .setZone('America/New_York')
    .toFormat('M/d/yy');
  return date;
}
